(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const isExaminedAtom = svs.lyckoplatsen.shared_mybets_wager.jotai.atoms.isExaminedAtom;
const _React = React,
  useMemo = _React.useMemo,
  useState = _React.useState,
  useEffect = _React.useEffect;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_result.jotai.atoms,
  selectedResultAtom = _svs$lyckoplatsen$com.selectedResultAtom,
  playCorrectionTlAtom = _svs$lyckoplatsen$com.playCorrectionTlAtom,
  correctionStepAtom = _svs$lyckoplatsen$com.correctionStepAtom,
  distributionArrayAtom = _svs$lyckoplatsen$com.distributionArrayAtom,
  isLatestResultAtom = _svs$lyckoplatsen$com.isLatestResultAtom;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue,
  useSetAtom = _jotai.useSetAtom;
const _svs$lyckoplatsen$com2 = svs.lyckoplatsen.components.shared_constants,
  CORRECTION_STEP = _svs$lyckoplatsen$com2.CONSTANTS.CORRECTION_STEP,
  productMapping = _svs$lyckoplatsen$com2.productMapping;
const _svs$lyckoplatsen$com3 = svs.lyckoplatsen.components.shared_result.react.components,
  ResultDrawStartPrimary = _svs$lyckoplatsen$com3.ResultDrawStartPrimary,
  ResultDrawStartSecondary = _svs$lyckoplatsen$com3.ResultDrawStartSecondary,
  ResultDrawTopWin = _svs$lyckoplatsen$com3.ResultDrawTopWin,
  MapCorrection = _svs$lyckoplatsen$com3.MapCorrection;
const getDistributionArray = svs.lyckoplatsen.utils.page_result.getDistributionArray;
const ResultDraw = () => {
  const isExamined = useAtomValue(isExaminedAtom);
  const correctionStep = useAtomValue(correctionStepAtom);
  const result = useAtomValue(selectedResultAtom);
  const play = useAtomValue(playCorrectionTlAtom);
  const isLatestResult = useAtomValue(isLatestResultAtom);
  const isPrimary = productMapping.isLyckoplatsenPrimary(result.productId);
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    resultDrawStartVisible = _useState2[0],
    setResultDrawStartVisible = _useState2[1];
  const setDistributionArray = useSetAtom(distributionArrayAtom);
  const distribution = result.distribution,
    distributionDrawItems = result.distributionDrawItems,
    drawNumber = result.drawNumber;
  const todaysWin = parseInt(distribution[0].amountSek, 10);
  const distributionArray = useMemo(() => {
    if (distributionDrawItems.length > 0) {
      return getDistributionArray({
        winPlan: distributionDrawItems,
        win: todaysWin,
        drawNumber
      });
    }
    return null;
  }, [distributionDrawItems, todaysWin, drawNumber]);
  setDistributionArray(distributionArray);
  useEffect(() => {
    if (isPrimary && correctionStep === CORRECTION_STEP.TOPWIN || !isPrimary && correctionStep === CORRECTION_STEP.PLACE) {
      setResultDrawStartVisible(true);
    }
  }, [correctionStep, isPrimary]);
  return React.createElement("div", {
    className: "lp-draw fc-white ".concat(play ? 'play' : 'paused', " ").concat(isPrimary ? 'primary' : 'secondary', " ").concat(isLatestResult ? 'latest' : '', " ").concat(isExamined ? '' : 'not-examined')
  }, isPrimary && correctionStep === CORRECTION_STEP.TOPWIN && React.createElement(ResultDrawStartPrimary, null), resultDrawStartVisible && !isPrimary && correctionStep === CORRECTION_STEP.PLACE && React.createElement(ResultDrawStartSecondary, {
    setResultDrawStartVisible: setResultDrawStartVisible
  }), React.createElement(ResultDrawTopWin, {
    className: "gsap-top-win gsap-hide"
  }), (correctionStep === CORRECTION_STEP.PLACE || correctionStep === CORRECTION_STEP.DISTANCE) && React.createElement(MapCorrection, null));
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  ResultDraw
});

 })(window);